import { combineReducers } from 'redux'
import {
  createRequestReducer,
  createReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeComments = data => {
  const comment = new schema.Entity('comments')
  return normalize(data, [comment])
}

const CommentsReducer = combineReducers({
  fetchCommentsRequest: createRequestReducer('COMMENTS_STORE:FETCH'),
  pagination: createReducer(null, {
    'COMMENTS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account.comments_pagination
  }),
  comments: createReducer(null, {
    'COMMENTS_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeComments(response.data.account.comments)
  })
})

export default CommentsReducer
